




















import i18n from 'vue-i18n';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import EventBus from '../../../eventBus.js';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';

export default {
    name: 'CoSharableInput',
    i18n: {
        messages: {
            en: {
                clickToCopy: 'Click to copy this value to your clipboard',
                copiedToClipboard: 'Copied to clipboard',
            },
            de: {
                clickToCopy: 'Zum Kopieren in die Zwischenablage klicken',
                copiedToClipboard: 'In die Zwischenablage kopiert',
            },
        },
    },
    components: {
        CoInput,
        CoTippy,
    },
    props: {
        label: String,
        value: String,
        type: String,
        placeholder: String,
        readonly: Boolean,
        icon: String,
    },
    methods: {
        copyValueToClipboard() {
            navigator.clipboard.writeText(this.value);
            EventBus.$emit('INFO', {
                Message: this.$t('copiedToClipboard'),
                Details: '',
            });
        },
    },
};
